import { render, staticRenderFns } from "./last-record-ref.vue?vue&type=template&id=6be4736a&scoped=true&"
import script from "./last-record-ref.vue?vue&type=script&lang=js&"
export * from "./last-record-ref.vue?vue&type=script&lang=js&"
import style0 from "./last-record-ref.vue?vue&type=style&index=0&id=6be4736a&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be4736a",
  null
  
)

export default component.exports